Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.advanceAnimationByFrame = advanceAnimationByFrame;
exports.advanceAnimationByTime = advanceAnimationByTime;
exports.getAnimatedStyle = getAnimatedStyle;
exports.setUpTests = setUpTests;
exports.withReanimatedTimer = withReanimatedTimer;
function withReanimatedTimer() {}
function advanceAnimationByTime() {}
function advanceAnimationByFrame() {}
function setUpTests() {}
function getAnimatedStyle() {}
